import { useContext, createContext, useState } from "react"

const WorkoutContext = createContext()

const WorkoutProvider = ({ children }) => {
    const [workoutData, setWorkoutData] = useState({})

    return (
        <WorkoutContext.Provider value={{ workoutData, setWorkoutData }}>
        {children}
        </WorkoutContext.Provider>
    )

}

export default WorkoutProvider

export const useWorkout = () => {
  return useContext(WorkoutContext)
}